(function () {
  if (window.__conciergeApplyMotionInit) return;
  window.__conciergeApplyMotionInit = true;

  function revealEl(el) {
    var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
    el.style.transitionDelay = delay + 'ms';
    el.classList.add('is-revealed');
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = 1300;
    var start = null;
    function ease(x) {
      return 1 - Math.pow(1 - x, 3);
    }
    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      el.textContent = (target * ease(progress)).toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function tokenizeWordReveal(el) {
    var words = [];
    function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (part) {
            if (part === '') return;
            if (/^\s+$/.test(part)) {
              frag.appendChild(document.createTextNode(part));
            } else {
              var span = document.createElement('span');
              span.textContent = part;
              span.className = 'word-reveal-token';
              frag.appendChild(span);
              words.push(span);
            }
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1) {
          walk(child);
        }
      });
    }
    walk(el);
    return words;
  }

  function initWordReveal(wordReveals) {
    if (!wordReveals.length) return;
    document.documentElement.classList.add('js-word-reveal');
    var groups = Array.prototype.map.call(wordReveals, function (el) {
      return { el: el, words: tokenizeWordReveal(el), complete: false };
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      groups.forEach(function (group) {
        group.el.classList.add('is-lit-all');
      });
      return;
    }

    var rafId = 0;

    function allComplete() {
      return groups.every(function (group) {
        return group.complete;
      });
    }

    function tick() {
      rafId = 0;
      if (document.hidden) return;

      var vh = window.innerHeight;
      var start = vh * 0.88;
      var end = vh * 0.3;
      var needsFrame = false;

      groups.forEach(function (group) {
        if (group.complete) return;

        var rect = group.el.getBoundingClientRect();
        var progress = Math.min(Math.max((start - rect.top) / (start - end), 0), 1);
        var litCount = Math.round(progress * group.words.length);
        group.words.forEach(function (word, i) {
          word.classList.toggle('is-lit', i < litCount);
        });

        if (progress >= 1) {
          group.complete = true;
          group.el.classList.add('is-lit-all');
        } else if (progress > 0) {
          needsFrame = true;
        }
      });

      if (needsFrame) rafId = requestAnimationFrame(tick);
    }

    function ensureRunning() {
      if (document.hidden || allComplete() || rafId) return;
      rafId = requestAnimationFrame(tick);
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) ensureRunning();
    });
    window.addEventListener('scroll', ensureRunning, { passive: true });
    window.addEventListener('resize', ensureRunning, { passive: true });

    ensureRunning();
  }

  function init() {
    var reveals = document.querySelectorAll('[data-reveal]');
    var counts = document.querySelectorAll('[data-count]');
    var wordReveals = document.querySelectorAll('[data-word-reveal]');

    initWordReveal(wordReveals);

    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              revealEl(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
      );
      Array.prototype.forEach.call(reveals, function (el) {
        revealObserver.observe(el);
      });

      var countObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              countUp(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.4 }
      );
      Array.prototype.forEach.call(counts, function (el) {
        countObserver.observe(el);
      });
    } else {
      Array.prototype.forEach.call(reveals, revealEl);
      Array.prototype.forEach.call(counts, countUp);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
